import Resource from '@/services/resources/common';

// question type
export default class GraphTypeResource extends Resource {
  constructor(entrypoint = '/graph_types', alias = 'GraphType') {
    super(entrypoint, alias);
  }
}
